/*eslint eqeqeq: [ 0 ]*/
import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
// import 'typeface-roboto';
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
// import Select from '@material-ui/core/Select';
import {
  StepButtons,
  HomeTelCustom1,
  SpecialSelect,
  CurrencyCustom,
  ZipCustom
} from "../CommonComponents";
import { Consumer } from "./EWCCContext";
import styles from "../ewccstyle";
import Input from "@material-ui/core/Input";

const fundsrclist = [
  { value: "SB", label: "Salary/Benefits" },
  { value: "AL", label: "Allowances" },
  { value: "BI", label: "Business Income" },
  { value: "RM", label: "Remittance" },
  { value: "RT", label: "Retirement/Separation" },
  { value: "OTH", label: "Others" }
];

const worktypelist = [
  { value: "PV", label: "Private" },
  { value: "GV", label: "Government" },
  { value: "SE", label: "Self-employed" },
  { value: "EE", label: "Employed" },
  { value: "RT", label: "Retired" },
  { value: "OTH", label: "Others" }
];

const workposlist = [
  { value: "CK", label: "Clerk" },
  { value: "JO", label: "Officer - Junior/Supervisor" },
  { value: "SO", label: "Officer - Senior/Manager" },
  { value: "EX", label: "Executive(AVP &amp; Up)" },
  { value: "SE", label: "Self-Employed/Proprietor" },
  { value: "OTH", label: "Others" }
];

const worknaturelist = [
  { value: "AGRIMIN", label: "Agricultural/Mining" },
  { value: "BANK", label: "Banking" },
  { value: "BPO", label: "BPO" },
  { value: "BUSCOM", label: "Business/Commercial Services" },
  { value: "CSP", label: "Community/Social/Personal" },
  { value: "CONS", label: "Construction" },
  { value: "FIN", label: "Financing" },
  { value: "GOV", label: "Government" },
  { value: "INS", label: "Insurance " },
  { value: "MAN", label: "Manufacturing" },
  { value: "REAL", label: "Real Estate " },
  { value: "TC", label: "Transportation/Communication" },
  { value: "UTIL", label: "Utilities" },
  { value: "WR", label: "Wholesale/Retail " },
  { value: "CCFBC", label: "Check Cashing Facilities/Bayad Center" },
  { value: "MCFED", label: "Money Changers/Foreign Exchange Dealer" },
  { value: "MTRA", label: "Money Transmitters/Remittance Agents" },
  { value: "PAWN", label: "Pawnshop" }
];

const WorkAndFinances = withStyles(styles)(function(props) {
  const { activeStep, handleBack, classes } = props;
  return (
    <Consumer>
      {context => (
        <Formik
          initialValues={{
            fundSrc: context.fundSrc,
            workType: context.workType,
            workYear: context.workYear,
            workPos: context.workPos,
            workPos1: context.workPos1,
            workNature: context.workNature,
            workPos2: context.workPos2,
            businessName: context.businessName,
            businessDept: context.businessDept,
            businessAddress: context.businessAddress,
            businessZip: context.businessZip,
            businessPhone: context.businessPhone,
            businessIncome: context.businessIncome
            // businessName: context.businessName,
          }}
          validationSchema={Yup.object().shape({
            workType: Yup.string().required("Employment is required"),
            workYear: Yup.number()
              .min(0, "Invalid input")
              .integer("Invalid input")
              .required("Years with Present Employer/Business is required"),
            workPos: Yup.string().required("Position/Rank is required"),
            workPos2: Yup.string().required("Job Title/Occupation is required").max(200,"Text too long"),
            workNature: Yup.string().required(
              "Nature of Present Business is required"
            ),
            businessName: Yup.string().required(
              "Company/Business Name is required"
            ).max(200,"Text too long"),
            businessAddress: Yup.string().required(
              "Company/Business Address is required"
            ),
            businessDept: Yup.string().max(200,"Text too long"),
            businessPhone: Yup.string().max(30, "Number too long").required("Company/Business Phone Number is required"),
            businessIncome: Yup.string().required(
              "Gross Annual Income is required"
            ).max(20,"Invalid amount"),
            // businessZip: Yup.number()
            //   .positive("Invalid Zipcode")
            //   .integer("Invalid Zipcode")
            //   .min(1000,"Invalid Zipcode"),
          })}
          onSubmit={(values, actions) => {
            context.updateState("fundSrc", values.fundSrc);
            context.updateState("workType", values.workType);
            context.updateState("workYear", values.workYear);
            context.updateState("workPos", values.workPos);
            context.updateState("workPos1", values.workPos1);
            context.updateState("workNature", values.workNature);
            context.updateState("workPos2", values.workPos2);
            context.updateState("businessName", values.businessName);
            context.updateState("businessDept", values.businessDept);
            context.updateState("businessAddress", values.businessAddress);
            context.updateState("businessZip", values.businessZip);
            context.updateState("businessPhone", values.businessPhone);
            context.updateState("businessIncome", values.businessIncome);
            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {props => {
            const {
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              isSubmitting
            } = props;

            return (
              <form noValidate autoComplete="off">
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.fundSrc && touched.fundSrc ? true : false}
                >
                  <InputLabel htmlFor="fundSrc">Source of Wealth/Income </InputLabel>
                  <SpecialSelect
                    id="fundSrc"
                    name="fundSrc"
                    value={values.fundSrc}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={fundsrclist}
                  />

                  {/* <Select
                                            native
                                            value={values.fundSrc}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            inputProps={{
                                                name: 'fundSrc',
                                                id: 'fundSrc',
                                            }}
                                        >
                                            <option value="" />
                                            <option value="SB">Salary/Benefits</option>
                                            <option value="AL">Allowances</option>
                                            <option value="BI">Business Income</option>
                                            <option value="RM">Remittance</option>
                                            <option value="RT">Retirement/Separation</option>
                                            <option value="OTH">Others</option>
                                        </Select> */}
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.fundSrc && touched.fundSrc && <>{errors.fundSrc}</>}
                  </FormHelperText>
                </FormControl>

                {values.fundSrc.value == "OTH" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      id="fundSrc1"
                      label="Others"
                      className={classes.textField}
                      value={values.fundSrc1}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </FormControl>
                ) : (
                  ""
                )}

                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.workType && touched.workType ? true : false}
                >
                  <InputLabel htmlFor="workType">Employment *</InputLabel>

                  <SpecialSelect
                    id="workType"
                    name="workType"
                    value={values.workType}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={worktypelist}
                  />

                  {/* <Select
                                            native
                                            value={values.workType}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            inputProps={{
                                                name: 'workType',
                                                id: 'workType',
                                            }}
                                        >
                                            <option value="" />
                                            <option value="PV">Private</option>
                                            <option value="GV">Government</option>
                                            <option value="SE">Self-employed</option>
                                            <option value="EE">Employed</option>
                                            <option value="RT">Retired</option>
                                            <option value="OTH">Others</option>
                                        </Select> */}

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.workType && touched.workType && (
                      <>{errors.workType}</>
                    )}
                  </FormHelperText>
                </FormControl>

                {values.workType.value == "OTH" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      id="employment1"
                      label="Others"
                      className={classes.textField}
                      value={values.employment1}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </FormControl>
                ) : (
                  ""
                )}

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="workYear"
                    label="Years with Present Employer/Business "
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.workYear}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="number"
                    helperText={
                      errors.workYear && touched.workYear ? errors.workYear : ""
                    }
                    error={errors.workYear && touched.workYear ? true : false}
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.workPos && touched.workPos ? true : false}
                >
                  <InputLabel htmlFor="workPos">Position/Rank *</InputLabel>
                  <SpecialSelect
                    id="workPos"
                    name="workPos"
                    value={values.workPos}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={workposlist}
                  />
                  {/* <Select
                                            native
                                            value={values.workPos}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            inputProps={{
                                                name: 'workPos',
                                                id: 'workPos',
                                            }}
                                        >
                                            <option value="" />
                                            <option value="CK">Clerk</option>
                                            <option value="JO">Officer - Junior/Supervisor</option>
                                            <option value="SO">Officer - Senior/Manager</option>
                                            <option value="EX">Executive(AVP &amp; Up)</option>
                                            <option value="SE">Self-Employed/Proprietor</option>
                                            <option value="OTH">Others</option>
                                        </Select> */}
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.workPos && touched.workPos && <>{errors.workPos}</>}
                  </FormHelperText>
                </FormControl>

                {values.workPos.value == "OTH" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      id="workPos1"
                      label="Others"
                      className={classes.textField}
                      value={values.workPos1}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </FormControl>
                ) : (
                  ""
                )}

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="workPos2"
                    label="Job Title/Occupation"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.workPos2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.workPos2 && touched.workPos2 ? errors.workPos2 : ""
                    }
                    error={errors.workPos2 && touched.workPos2 ? true : false}
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.workNature && touched.workNature ? true : false}
                >
                  <InputLabel htmlFor="workNature">
                    Nature of Present Business *
                  </InputLabel>
                  <SpecialSelect
                    id="workNature"
                    name="workNature"
                    value={values.workNature}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={worknaturelist}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.workNature && touched.workNature && (
                      <>{errors.workNature}</>
                    )}
                  </FormHelperText>
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="businessName"
                    label="Company/Business Name"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.businessName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ minWidth: 300 }}
                    helperText={
                      errors.businessName && touched.businessName
                        ? errors.businessName
                        : ""
                    }
                    error={
                      errors.businessName && touched.businessName ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    // required
                    id="businessDept"
                    label="Department"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.businessDept}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="businessAddress"
                    label="Company/Business Address"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.businessAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    // helperText="Limit input to 120 characters including spaces"
                    // fullWidth
                    helperText={
                      errors.businessAddress && touched.businessAddress
                        ? errors.businessAddress
                        : "Limit input to 120 characters including spaces"
                    }
                    error={
                      errors.businessAddress && touched.businessAddress
                        ? true
                        : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    // required
                    id="businessZip"
                    label="Zip Code"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.businessZip}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                      inputComponent: ZipCustom
                    }}
                    helperText={
                      errors.businessZip && touched.businessZip
                        ? errors.businessZip
                        : ""
                    }
                    error={
                      errors.businessZip && touched.businessZip ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="businessPhone"
                    label="Business Phone"
                    className={classes.textField}
                    value={values.businessPhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.businessPhone && touched.businessPhone
                        ? errors.businessPhone
                        : " If provincial, include area code"
                    }
                    error={
                      errors.businessPhone && touched.businessPhone ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="businessIncome"
                    label="Gross Annual Income"
                    value={values.businessIncome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.businessIncome
                        ? errors.businessIncome
                        : "Should match income document submitted"
                    }
                    error={
                      errors.businessIncome && touched.businessIncome
                        ? true
                        : false
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom
                    }}
                  />
                </FormControl>

                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

export default WorkAndFinances;
